export default __webpack_public_path__ + "static/media/jw_illusheader_pin_ILLUS.1a522cb5.png";